//shoes/src/services/wishlist.api.js
import { apiRequest } from "./api";

export const getMyWishlist = () => {
  return apiRequest("/wishlist");
};

export const toggleWishlistApi = (product_id) => {
  return apiRequest("/wishlist/toggle", {
    method: "POST",
    body: JSON.stringify({ product_id }),
  });
};
